import { Component } from '@angular/core';

@Component({
  selector: 'app-exce-pdf-content',
  imports: [],
  templateUrl: './exce-pdf-content.component.html',
  styleUrl: './exce-pdf-content.component.css'
})
export class ExcePdfContentComponent {

}
